import { useMutation, useQuery } from '@tanstack/react-query'

import type { VerifyPromoCodeRequest, VerifyPromoCodeResponse } from '../types/payment.js'

import { apiClient } from '../lib/client.js'

export const useDecryptAxeptaData = (data?: string, len?: string) =>
  useQuery({
    enabled: !!data && !!len,
    queryFn: async () => {
      const response = await apiClient.client.get<Record<string, string>>(
        '/payment/axepta-decrypt',
        { params: { Data: data, Len: len } }
      )
      return response.data
    },
    queryKey: ['axepta-decrypt', data, len],
    retry: false,
  })

export const useVerifyPromoCode = () =>
  useMutation({
    mutationFn: async ({ code }: VerifyPromoCodeRequest) => {
      const response = await apiClient.client.post<VerifyPromoCodeResponse>(
        `/payment/verify-promo-code/${code}`
      )
      return response.data
    },
  })
